import styled from "styled-components";
import {
  borderWidth,
  colors,
  sizes,
  spacings,
} from "../../../../assets/themes";
import {
  Avatar,
  Badge,
  Block,
  Body14,
  Body16,
  Icon,
  List,
} from "../../../../components";
import {
  AVATAR_GROUP,
  BADGE,
  LIST,
} from "../../../../components/Styles/variants";
import polyglot from "../../../../utils/polyglot";

const StyledAlert = styled(List.Item)`
  background-color: ${colors.primaryLight};
  border: solid ${borderWidth.s} ${colors.border};
`;

const JobContent = ({
  pending_offers_avatars,
  pending_offers_wording,
  pending_offers_title,
}) =>
  pending_offers_avatars || pending_offers_wording ? (
    <Block display="flex" flexDirection="column" gap={spacings.m}>
      {pending_offers_avatars && (
        <Block>
          <StyledAlert
            withGutters
            shape={LIST.SHAPE.ROUND}
            divider={false}
            LeftComponent={() => (
              <Block alignSelf="start">
                <Badge
                  position={BADGE.POSITION.TOP_RIGHT}
                  dot
                  outlineColor={colors.primaryLight}
                >
                  <Icon.Large name="bell" color={colors.primary} />
                </Badge>
              </Block>
            )}
          >
            <Body16 strong color={colors.primary}>
              {polyglot.t("dashboard.job.offers_received_plural", {
                count: pending_offers_avatars.length,
              })}
            </Body16>
            <Avatar.Group
              orientation={AVATAR_GROUP.ORIENTATION.HORIZONTAL}
              max={3}
              outlineColor={colors.backgroundLight}
            >
              {pending_offers_avatars.map((avatar) => (
                <Avatar src={avatar} size={sizes.size36} name={avatar.name} />
              ))}
            </Avatar.Group>
          </StyledAlert>
        </Block>
      )}
      {pending_offers_wording && (
        <Block>
          <StyledAlert
            withGutters
            divider={false}
            shape={LIST.SHAPE.ROUND}
            LeftComponent={() => (
              <Block alignSelf="start">
                <Icon.Large
                  name="bell"
                  color={colors.primary}
                  css="align-self: flex-start"
                />
              </Block>
            )}
          >
            <Body16 strong color={colors.primary}>
              {pending_offers_title}
            </Body16>
            <Body14 color={colors.muted}>{pending_offers_wording}</Body14>
          </StyledAlert>
        </Block>
      )}
    </Block>
  ) : null;

export default JobContent;
